// extracted by mini-css-extract-plugin
export default {"DoubleLine2":"ZmFGSu","doubleLine2":"ZmFGSu","top":"BdrL6T","bottom":"oSOVXc","tile":"MXadOM"};